<template>
  <tr :style="pending && pending.death > 0 ? 'background-color: #d6d6d6' : ''">
    <td class="align-middle " style="width: 140px"> {{ member.info.nick }}</td>
    <td class="align-middle mr-2">{{ member.kills + (pending ? pending.killDelta : 0) }}</td>
    <td class="p-1 align-middle">
      <b-btn :disabled="showEventData?.type === 'ended'"
             @click="increaseKill()"
             variant="primary"
             class="p-1 mr-4">
        <i class="fa fa-caret-up p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="showEventData?.type === 'ended'"
             @click="decreaseKill()"
             variant="danger"
             class="p-1 mr-4">
        <i class="fa fa-caret-down p-1 px-2"></i>
      </b-btn>
    </td>
    <td class="p-1 align-middle">
      <b-btn :disabled="showEventData?.type === 'ended'"
             @click="toggleDeath()"
             :variant="pending && pending.death > 0 ? 'dark' : 'primary'"
             class="px-2 mr-4">
        {{ deathLabel }}
      </b-btn>
    </td>
  </tr>
</template>

<script>
import {BookAdapterMixin} from "@/mixins/Book/BookAdapterMixin";

export default {
  name: "RowInHostsBook",
  mixins: [BookAdapterMixin],
  props: {
    member: {
      type: Object,
      default: null
    },
    team: {
      type: Object,
      default: null
    },
    pending: {
      type: Object,
      default: null,
    },
  },
  computed: {
    deathLabel() {
      return this.pending && this.pending.death > 0 ? 'Нет' : 'Да'
    },
  },
  methods: {
    increaseKill() {
      if (!this.pending) return
      this.$emit('update-pending', {
        userId: this.member.user_id,
        killDelta: this.pending.killDelta + 1,
        death: this.pending.death,
      })
    },
    decreaseKill() {
      if (!this.pending) return
      this.$emit('update-pending', {
        userId: this.member.user_id,
        killDelta: this.pending.killDelta - 1,
        death: this.pending.death,
      })
    },
    toggleDeath() {
      if (!this.pending) return
      this.$emit('update-pending', {
        userId: this.member.user_id,
        killDelta: this.pending.killDelta,
        death: this.pending.death > 0 ? 0 : 1,
      })
    },
  }
}
</script>

<style scoped>

</style>
